import { inject, Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "../../../../Environments/Environment";
import { SearchFileRequest } from "../Dto/SearchFileRequest";
import { SearchFileResponse } from "../Dto/SearchFileResponse";
import { UploadFileRequest } from "../Dto/UploadFileRequest";
import { File } from "../Dto/FileModel";
import { firstValueFrom } from "rxjs";

/**
 * File API client for managing file operations.
 * Uses adminServiceUrl from environment to keep backend base configurable per build.
 */
@Injectable({ providedIn: "root" })
export class FileApi {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.adminServiceUrl;

  async searchFiles(payload: SearchFileRequest): Promise<SearchFileResponse> {
    let params = new HttpParams();

    if (payload.search) params = params.set("search", payload.search);
    if (payload.name) params = params.set("name", payload.name);
    if (payload.originalName) params = params.set("originalName", payload.originalName);
    if (payload.mimeType) params = params.set("mimeType", payload.mimeType);
    if (payload.createdAtFrom) params = params.set("createdAtFrom", payload.createdAtFrom);
    if (payload.createdAtTo) params = params.set("createdAtTo", payload.createdAtTo);
    if (payload.page) params = params.set("page", payload.page.toString());
    if (payload.limit) params = params.set("limit", payload.limit.toString());

    return await firstValueFrom(this.http.get<SearchFileResponse>(`${this.baseUrl}/files`, { params, withCredentials: true }));
  }

  async uploadFile(file: globalThis.File, payload: UploadFileRequest): Promise<File> {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("folder", payload.folder);

    return await firstValueFrom(this.http.post<File>(`${this.baseUrl}/files`, formData, { withCredentials: true }));
  }

  async uploadFiles(files: globalThis.File[], payload: UploadFileRequest): Promise<File[]> {
    const formData = new FormData();
    files.forEach((file) => formData.append("files", file));
    formData.append("folder", payload.folder);

    return await firstValueFrom(this.http.post<File[]>(`${this.baseUrl}/files/batch`, formData, { withCredentials: true }));
  }

  async deleteFile(name: string): Promise<void> {
    return await firstValueFrom(
      this.http.delete<void>(`${this.baseUrl}/files`, {
        body: { name },
        withCredentials: true,
      }),
    );
  }
}
